import { render, staticRenderFns } from "./CM-menu.vue?vue&type=template&id=40e69d2e&scoped=true"
import script from "./CM-menu.vue?vue&type=script&lang=js"
export * from "./CM-menu.vue?vue&type=script&lang=js"
import style0 from "./CM-menu.vue?vue&type=style&index=0&id=40e69d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e69d2e",
  null
  
)

export default component.exports